import { MANAGER_FOR_EMPLOYEE_URL } from './endpoints.constants';

const API_URL = process.env.API_URL;
const MANAGER_FOR_EMPLOYEE = `${API_URL}/${MANAGER_FOR_EMPLOYEE_URL.ROOT_MANAGER_FOR_EMPLOYEE}`;

const ENDPOINTS_MANAGER_FOR_EMPLOYEE = {
  get: {
    managerForEmployee: (employeeId) => `${MANAGER_FOR_EMPLOYEE}/${employeeId}`,
  },
};

export {
  ENDPOINTS_MANAGER_FOR_EMPLOYEE
};


// WEBPACK FOOTER //
// ./client/app/common/endpoints/manager-for-employee.endpoints.js